import { isJsonString } from "../helpers";

function getAllChildNodes(nodes, id) {
  if (!nodes[id]) {
    return [];
  }

  if (
    nodes[id].nodes.length === 0 &&
    Object.values(nodes[id].linkedNodes).length === 0
  ) {
    return [];
  }

  return [
    ...nodes[id].nodes,
    ...Object.values(nodes[id].linkedNodes),
    ..._.flatten(
      nodes[id].nodes.map((id) => {
        return getAllChildNodes(nodes, id);
      }),
    ),
    ..._.flatten(
      Object.values(nodes[id].linkedNodes).map((id) => {
        return getAllChildNodes(nodes, id);
      }),
    ),
  ];
}

const optimizeNodeTree = (tree) => {
  if (tree && isJsonString(tree)) {
    var page = JSON.parse(tree);

    // Remove isolated nodes
    var usedNodes = getAllChildNodes(page, "ROOT");
    usedNodes = [...usedNodes, "ROOT"];

    page = Object.fromEntries(usedNodes.map((col) => [col, page[col]]));

    return JSON.stringify(page);
  }
  return tree;
};

export { optimizeNodeTree };
